import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './components/dashboard/dashboard.component';
// Domains
import { DomainsComponent } from './components/domains/domains.component';
import { AddNameComponent } from './components/domains/add-name/add-name.component';
// Employees
import { EmployeesComponent } from './components/employees/employees.component';
import { EmployeeAddComponent } from './components/employees/add/employee-add.component';
import { EmployeeAddInstructorComponent } from './components/employees/add-instructor/employee-add-instructor.component';
import { EmployeeDetailsComponent } from './components/employees/details/employee-details.component';
import { EmployeeEditComponent } from './components/employees/edit/employee-edit.component';
// Organization Details
import { OrganizationDetailsComponent } from './components/organization-details/organization-details.component';
import { OrganizationDetailsEditComponent } from './components/organization-details/organization-details-edit/organization-details-edit.component';
// Credit
import { CreditInfoComponent } from 'app/organization/components/credit/credit-info/credit-info.component';
import { CreditFormComponent } from 'app/organization/components/credit/credit-form/credit-form.component';
import { CreditNotificationComponent } from 'app/organization/components/credit/credit-notification/credit-notification.component'
import { CreditComponent } from 'app/organization/components/credit/credit.component';
import { CreditErrorComponent } from './components/credit/credit-error/credit-error.component';
import { CreditDetailsComponent } from './components/credit/credit-details/credit-details.component';
// Communication
import { SolarEmailsComponent } from './components/communication/emails/components/emails.component';
import { SolarEmailDetailsComponent } from './components/communication/emails/components/details/email-details.component';
import { TemplatesComponent } from './components/communication/templates/components/templates.component';
import { CreateTemplateComponent } from './components/communication/templates/components/create/create-template.component';
import { CommunicationDashboardComponent } from './components/communication/components/dashboard/dashboard.component';
import { VenuesComponent } from './components/venues/components/venues.component';
import { VenueAddComponent } from './components/venues/components/add/venue-add.component';
import { VenueEditComponent } from './components/venues/components/edit/venue-edit.component';
import { ApprovalsDashboardComponent } from './components/approvals/dashboard/approvals-dashboard.component';
import { ApprovedRulesComponent } from './components/approvals/approved-rules/approved-rules.component';
import { TransactionApprovalsComponent } from './components/approvals/transacion-aprovals/transacion-aprovals.component';
import { ConsumptionRequestsApprovalsComponent } from './components/approvals/consumption-requests-approvals/consumption-requests-approvals.component';
import {CertificatesComponent} from './components/certificates/components/certificates.component';
import {CertificateDetailsComponent} from './components/certificates/components/details/certificate-details.component';

const organizationRoutes: Routes = [
    {
        path: '', data: { breadcrumb: 'Organization Management' }, children: [
            { path: '', component: DashboardComponent, data: { breadcrumb: 'Organization Management' } },

            {
                path: 'domains', data: { breadcrumb: 'Domains' }, children: [
                    { path: '', component: DomainsComponent, data: { breadcrumb: 'Domains' } },
                    { path: 'add-name/:id', component: AddNameComponent, data: { breadcrumb: 'Add Domain Name' } },
                ]
            },
            {
                path: 'users', data: { breadcrumb: 'Users' }, children: [
                    { path: '', component: EmployeesComponent, data: { breadcrumb: 'Users' } },
                    { path: ':id/details', component: EmployeeDetailsComponent, data: { breadcrumb: 'Details' } },
                    { path: ':id/edit', component: EmployeeEditComponent, data: { breadcrumb: 'Edit' } },
                    { path: 'add', component: EmployeeAddComponent, data: { breadcrumb: 'Add' } },
                    { path: 'add-instructor', component: EmployeeAddInstructorComponent, data: { breadcrumb: 'Add Instructor' } }
                ]
            },
            {
                path: 'organization-details', data: { breadcrumb: 'Organization Details' }, children: [
                    { path: '', component: OrganizationDetailsComponent, data: { breadcrumb: 'Organization Details' } },
                    { path: ':id/edit', component: OrganizationDetailsEditComponent, data: { breadcrumb: 'Edit' } },
                ]
            },
            {
                path: 'credit', data: { breadcrumb: 'Credit Applications' }, children: [
                    { path: '', component: CreditComponent, data: { breadcrumb: 'Credit Applications' } },
                    { path: 'info', component: CreditInfoComponent, data: { breadcrumb: 'Credit Application Info' } },
                    { path: 'application', component: CreditFormComponent, data: { breadcrumb: 'Credit Application Form' } },
                    { path: 'notification', component: CreditNotificationComponent, data: { breadcrumb: 'Credit Notification' } },
                    { path: 'error', component: CreditErrorComponent, data: { breadcrumb: 'Info' } },
                    { path: ':id/details', component: CreditDetailsComponent, data: { breadcrumb: 'Credit Application Details' } }
                ]
            },
            {
                path: 'communications', data: { breadcrumb: 'Communications' }, children: [
                    { path: '', component: CommunicationDashboardComponent, data: { breadcrumb: 'Communications' } },
                    {
                        path: 'emails', data: { breadcrumb: 'Emails', restore: true }, children: [
                            { path: '', component: SolarEmailsComponent, data: { breadcrumb: 'Emails' } },
                            { path: ':id/details', component: SolarEmailDetailsComponent, data: { breadcrumb: 'Details' } }
                        ]
                    },
                    {
                        path: 'templates', data: { breadcrumb: 'Templates', restore: true }, children: [
                            { path: '', component: TemplatesComponent, data: { breadcrumb: 'Templates' } },
                            { path: 'create', component: CreateTemplateComponent, data: { breadcrumb: 'Create' } },
                            { path: ':id/edit', component: CreateTemplateComponent, data: { breadcrumb: 'Edit', edit: true } },
                        ]
                    }
                ]
            },
            {
                path: 'venues', data: { breadcrumb: 'Venues' }, children: [
                    { path: '', component: VenuesComponent, data: { breadcrumb: 'Venues', restore: true } },
                    { path: 'add', component: VenueAddComponent, data: { breadcrumb: 'Add' } },
                    { path: 'edit/:id', component: VenueEditComponent, data: { breadcrumb: 'Edit' } }
                ]
            },
            {
                  path: 'certificates', data: { breadcrumb: 'Certificates' }, children: [
                      { path: '', component: CertificatesComponent, data: { breadcrumb: 'Certificates', restore: true } },
                      { path: ':id/details', component: CertificateDetailsComponent, data: { breadcrumb: 'Details' } }

                  ]
            },
            {
                path: 'approvals', data: { breadcrumb: 'Approvals' }, children: [
                    { path: '', component: ApprovalsDashboardComponent },
                    { path: 'approved-rules', component: ApprovedRulesComponent, data: { breadcrumb: 'Approval Rules' } },
                    { path: 'transaction-approvals', component: TransactionApprovalsComponent, data: { breadcrumb: 'Transaction Approvals' } },
                    { path: 'consumption-requests-approvals', component: ConsumptionRequestsApprovalsComponent, data: { breadcrumb: 'Consumption Requests Approvals' } },
                ]
            }
        ]
    }
];


export const organizationRouting = RouterModule.forChild(organizationRoutes);



// WEBPACK FOOTER //
// ./src/app/organization/organization.routing.ts